/* eslint-disable camelcase */
import Model from '../../../Api/Models/Model';
import User from '../../../Api/Models/User';
import GetCasinoTransactionResponse from '../CRM/Responses/CasinoTransactionResponse';

import CasinoGame from './CasinoGame';

export default class CasinoTransaction extends Model {
    readonly id: number;
    readonly casino_provider_id: number;
    readonly user_id: number;
    readonly currency_code: string;
    readonly casino_game_id: number;
    readonly casino_game_session_id: number;
    readonly casino_user_bonus_id?: number;
    readonly is_canceled: boolean;
    readonly action: CasinoTransactionAction;
    readonly type?: CasinoTransactionType;
    readonly amount: number;
    readonly amount_manager: number;
    readonly amount_usd: number;
    readonly external_token: string;
    readonly additional_data?: JSON;
    readonly session_id?: string;
    readonly updated_at: string;
    readonly created_at: string;

    // Relationships
    readonly user?: User;
    readonly casino_game?: CasinoGame;

    constructor(transaction: Partial<GetCasinoTransactionResponse>) {
        super();
        this.assignDataToProps(transaction, [
            'id',
            'casino_provider_id',
            'user_id',
            'currency_code',
            'casino_game_id',
            'casino_game_session_id',
            'casino_user_bonus_id',
            'is_canceled',
            'action',
            'type',
            'amount',
            'amount_manager',
            'amount_usd',
            'external_token',
            'additional_data',
            'updated_at',
            'created_at',
            'user',
            'casino_game',
            'session_id',
        ]);
    }
}

export enum CasinoTransactionAction {
    BET = 'bet',
    WIN = 'win',
    REFUND = 'refund',
    ROLLBACK = 'rollback',
    TIP = 'tip',
}

export enum CasinoTransactionType {
    JACKPOT = 'jackpot',
    TIPTO = 'tip_to',
    TIPFROM = 'tip_from',
    FREESPIN = 'freespin',
}
